'use strict';

var angular = require('angular');
var dependencies = ['restangular'];
module.exports = angular.module('AVRO.FaresOptimizer.Common.AlignSaveFaresUtil', dependencies).factory('FaresOptimizerAlignFaresService', require('./services/FaresOptimizerAlignFaresService')).factory('FaresOptimizerSaveAdjustedFaresService', require('./services/FaresOptimizerSaveAdjustedFaresService'));